import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2Cliente } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import * as SocioCrud from 'services/socio.service'

const SocioFormGroup = ({ fIsSubmitting, iError, values, setValues }) => {
  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      values._idSocio = pickedMember.value
      values.documentoSocio = data.numeroDocumento
      values.tipoDocumentoSocio = data.tipoDocumento
      values.nombreSocio = data.razonSocial

      setValues(values)
    })
  }

  const clickClear = () => {
    values._idSocio = ''
    values.nombreSocio = ''
    values.documentoSocio = ''
    values.tipoDocumentoSocio = ''

    setValues(values)
  }

  return (
    <>
      <Form.Group>
        <Form.Label text='CLIENTE' htmlFor='input-codigoRucSocio' md={3} alignRightAt='md' />
        <Col md={9}>
          {values._idSocio ? (
            <ClearInputGroup id='input-codigoRucSocio' iValue={`${values.documentoSocio} - ${values.nombreSocio}`} clickClear={clickClear} />
          ) : (
            <Select2Cliente disabled={fIsSubmitting} id='codigoRucSelect' onChange={onChangeSocioHandler} />
          )}
          {iError && <Form.Feedback type='invalid'>{iError}</Form.Feedback>}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(SocioFormGroup)
